/**
 * Helper Functions
 */
function initLinkTracking() {
  const trackElements = document.querySelectorAll(`a:not(#wv-authnav a)`);
  trackElements.forEach(addTracking);

  function addTracking(ele) {
    let nodeName = ele.nodeName;
    if (nodeName === "A") {
      // Get Type, Style, Text
      let { eleType, eleDescription, eleTarget } = getElementInfo(ele);

      !ele.hasAttribute("data-link-type") &&
        ele.setAttribute("data-link-type", eleType);
      !ele.hasAttribute("data-link-target") &&
        ele.setAttribute("data-link-target", eleTarget);
      !ele.hasAttribute("data-link-info") &&
        ele.setAttribute("data-link-info", eleDescription);
    }
  }

  function getElementInfo(ele) {
    let eleType = getElType(ele); //default
    let eleTarget = getElTarget(ele);
    let eleDescription = getElDescription(ele);

    return { eleType, eleTarget, eleDescription };
  }

  function getElTarget(ele) {
    return ele?.href.includes("worldvision.org") || ele?.href[0] == "#"
      ? "internal_link"
      : "outbound_link";
  }

  function getElDescription(ele) {
    // :'{click_text|image}:{destination_url}'
    let { hasIcon, hasImage, imgAlt } = getChildNodesInfo(ele);

    let eleInfo = ele.text.trim().length
      ? ele.text
      : hasImage
      ? imgAlt || "image"
      : hasIcon
      ? "icon"
      : "";

    let eleHref = ele?.href.includes("https")
      ? ele?.href.slice(8)
      : ele?.href.includes("http")
      ? ele?.href.slice(7)
      : "#";

    return `${eleInfo.replace(/\s+/g, " ").trim()}:${eleHref}`;
  }

  function getChildNodesInfo(ele) {
    const childNodes = ele.childNodes;
    let hasIcon = false;
    let hasImage = false;
    let imgAlt = "";

    childNodes.forEach((node) => {
      if (node.nodeName == "I") {
        hasIcon = true;
      }
      if (node.nodeName == "IMG") {
        hasImage = true;
        imgAlt = node.alt || "";
      }
    });

    return { hasImage, imgAlt, hasIcon };
  }

  function getElType(ele) {
    let eleType = "text";
    const eleClassValue = ele.getAttributeNode("class")?.value || "";
    const eleDataSet = ele.dataset;

    let { hasIcon, hasImage } = getChildNodesInfo(ele);

    if (eleClassValue.includes("btn")) {
      eleType = "button";
    } else if (
      eleClassValue.includes("fa-plus") ||
      eleClassValue.includes("fa-minus") ||
      eleClassValue.includes("vc_toggle_icon")
    ) {
      eleType = "collapsible";
    } else if (
      eleDataSet.hasOwnProperty("vcTabs") ||
      eleClassValue.includes("toggle")
    ) {
      eleType = "tab";
    } else if (hasIcon) {
      eleType = "icon";
    } else if (hasImage) {
      eleType = "image";
    }

    return eleType;
  }
}

export default initLinkTracking;